<!--  -->
<template>
  <div class="page" :class="{ active: isApp || miniprogram }">
    <common-title
      v-if="!isApp && !miniprogram"
      :goHome="true"
      titleName="VIP课程体验"
      :zIndex="1000"
    ></common-title>
    <img
      class="main"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/main.png"
      alt=""
    />
    <div class="tab">
      <div
        class="subject"
        :class="{ active: idx === k }"
        @click="changeSubject(item, 1, k)"
        v-for="(item, k) in subjectList"
        :key="k"
      >
        {{ item.majorName }}
      </div>
    </div>
    <div class="sub-tab" v-if="childMajorList.length">
      <div
        class="major"
        :class="{ active: subIdx === k }"
        v-for="(item, k) in childMajorList"
        @click="changeSubject(item, 2, k)"
        :key="k"
      >
        {{ item.major }}
      </div>
    </div>
    <!-- 师资 -->
    <div class="teacher">
      <img
        class="title"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon5.png"
        alt=""
      />
      <div class="banner">
        <div class="slide" v-for="(item, k) in teacherList" :key="k" @click="toTeacherDetail(item)">
          <div class="head">
            <img
              class="img"
              :src="item.topicWebHead || require('../../assets/img/loginImg/default.png')"
              alt=""
            />
            <div class="name">{{ item.publicName }}</div>
          </div>
          <div class="desc">{{ item.teacherBrief }}</div>
        </div>
      </div>
    </div>
    <!-- 能量助力 -->
    <div class="server">
      <div class="energy">
        <img
          class="title"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon1.png"
          alt=""
        />
        <div class="list">
          <div class="item" v-for="(item, k) in energyList" :key="k" @click="toEnery(k)">
            <img :src="item.icon" alt="" />
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div class="safeguard">
        <img
          class="title"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon2.png"
          alt=""
        />
        <div class="box">
          <div
            class="child"
            v-for="(item, k) in wordVOList"
            :key="k"
            @click="toEnery(k + energyList.length)"
          >
            <img class="icon" :src="item.icon" alt="" />
            <p>{{ item.title }}</p>
            <img
              class="arrow"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="video" v-if="videoUrl">
      <img
        class="title"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon3.png"
        alt=""
      />
      <video
        v-if="videoUrl"
        poster="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/video.png"
        id="video"
        class="play"
        x5-video-player-type="h5"
        x5-playsinline
        playsinline
        webkit-playsinline="true"
        controls
        :src="videoUrl"
      ></video>
      <div class="empty"></div>
    </div>
    <div class="question" v-if="vipCourseDetail.vipCourseExperienceBenefitsRespVO">
      <img
        class="title"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon4.png"
        alt=""
      />
      <div v-html="vipCourseDetail.vipCourseExperienceBenefitsRespVO.problemSolved"></div>
    </div>
    <div class="foot" @click="toExperienceCourse"></div>
    <div class="chat" @click="openChat">
      <img
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon8.gif"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqSubject, reqCourseExperience, reqBokecc } from '@/api/vipProduct/index';
import { reqTeacherList, reqIsBuyProduct, reqCourseDetail } from '@/api/courseDetail/index';
import { reqSubOrder } from '@/api/pay/index';
import { gioPlatform } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      subjectList: [],
      childMajorList: [],
      idx: 0,
      subIdx: 0,
      experienceId: 0,
      vipCourseDetail: {},
      energyList: [],
      wordVOList: [],
      teacherList: [],
      videoUrl: '',
      playStatus: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 查学科
    async getSubject() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqSubject();
      const obj = {
        1: '数学',
        2: '英语',
        3: '政治',
        4: '经管',
        5: '专业课',
      };
      data.forEach((ele) => {
        Object.assign(ele, { majorName: obj[ele.subjectType] });
      });
      const temp = data[0];
      const { experienceId, subjectType, subjectMajorVOList } = temp;
      if (subjectType === 4 || subjectType === 5) {
        this.experienceId = subjectMajorVOList[0]?.experienceId;
      } else {
        this.experienceId = experienceId;
      }
      this.getCourseDetail(this.experienceId);

      this.subjectList = data;
      gio('track', 'LearningPageAccess_event', {
        enter_var: 'VIP课程体验',
        FunctionPage_var: data?.page_var,
        platform_var: gioPlatform(),
      });
    },
    // 查权益--根据ID
    async getCourseDetail(id) {
      const { data } = await reqCourseExperience(id);
      const { vipCourseExperienceBenefitsRespVO } = data;
      const { benefitsKineticEnergyVOList, benefitsExamAssuranceVOList, teacherIds, videoVid } =
        vipCourseExperienceBenefitsRespVO;
      this.vipCourseDetail = data;
      this.energyList = benefitsKineticEnergyVOList;
      this.wordVOList = benefitsExamAssuranceVOList;
      this.getTeacher(teacherIds);
      this.getVideoUrl(videoVid);
      this.$toast.clear();
    },
    // 查教师列表
    async getTeacher(teacherIds) {
      const { data } = await reqTeacherList(teacherIds);
      this.teacherList = data;
    },
    // 查视频URL
    async getVideoUrl(vid) {
      const { data } = await reqBokecc(vid);
      this.videoUrl = data?.video?.copy[0]?.playurl;
    },
    // 查开课状态
    async checkCourse(id) {
      const { data } = await reqIsBuyProduct(id);
      return data.length;
    },
    // 查课程sku
    async getCourseSku(id) {
      const { data } = await reqCourseDetail(id);
      const { productSkuRespVOList } = data;
      return productSkuRespVOList?.[0]?.productSkuId;
    },
    // 切换学科
    async changeSubject(item, type, index) {
      const { experienceId, subjectMajorVOList, subjectType } = item;
      this.experienceId = experienceId;
      if (type === 1) {
        this.idx = index;
        this.subIdx = 0;
        this.childMajorList = subjectMajorVOList || [];
      } else {
        this.subIdx = index;
      }
      if (subjectType === 4 || subjectType === 5) {
        this.experienceId = subjectMajorVOList?.[0]?.experienceId;
      }
      this.videoUrl = '';
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      await this.getCourseDetail(this.experienceId);
      this.$toast.clear();
    },
    // 跳教师详情
    toTeacherDetail(data) {
      this.setPause();
      const url = `${window.location.origin}/ark/vipTeacherDetail?teacherId=${data.id}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/vipTeacherDetail',
        query: {
          teacherId: data.id,
        },
      });
    },
    // 跳体验课
    jumpExperience() {
      const id = this.experienceId;
      this.setPause();
      const url = `${window.location.origin}/ark/vipExperienceProduct?id=${id}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      console.log(999);
      this.$router.push({
        path: '/vipExperienceProduct',
        query: {
          id,
        },
      });
    },
    toEnery(i) {
      const id = this.experienceId;
      this.setPause();
      const url = `${window.location.origin}/ark/vipService?id=${id}&active=${i}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/vipService',
        query: {
          active: i,
          id: this.experienceId,
        },
      });
    },
    openChat() {
      let url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=665818671c64a1000119f4b2';
      if (this.$root.$data.isApp) {
        url =
          'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66696197735feb0001e5a925';
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/vipCourse' },
        });
      }
    },
    // 去体验课
    async toExperienceCourse() {
      const { vipCourseExperienceConfigRespVO } = this.vipCourseDetail;
      const courseId = vipCourseExperienceConfigRespVO.experienceProductId;
      if (!this.userInfo?.id) {
        this.setPause();
        this.toLogin();
        return;
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const isBuy = await this.checkCourse(courseId);
      console.log(isBuy);
      if (isBuy) {
        this.$toast.clear();
        this.jumpExperience();
      } else {
        const skuid = await this.getCourseSku(courseId);
        const subData = {
          // 订单提交请求对象
          channelMark: 5, // 下单渠道 ：5学员端下单
          products: [
            {
              productId: courseId,
              quantity: 1, // 产品数量
              type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
            },
          ],
          terminalMark: this.$global.terminalMark,
          orderReferer: '',
          // eslint-disable-next-line no-undef
          ip: sessionStorage.getItem('cityIp') || '',
          orderUrl: window.location.href,
        };
        subData.products[0].productSkuId = skuid;
        const { code, msg } = await reqSubOrder(subData);
        if (code === 0) {
          this.$toast('试听课程领取成功');
          this.jumpExperience();
        } else {
          this.$toast(msg);
        }
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 暂停视频
    setPause() {
      this.playStatus = false;
      const video = document.getElementById('video');
      if (!video) return;
      video?.pause();
    },
  },
  created() {},
  mounted() {
    this.getSubject();
    document.title = 'VIP课程体验';
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page.active {
  padding-top: 0;
}
.page {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin:0 auto;
  padding-top: 100px;
  padding-bottom: 200px;
  background: #20170d;
  .main {
    width: 100%;
    height: 100%;
  }
  .tab {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    margin-left: 27px;
    overflow-x: scroll;
    white-space: nowrap;
    .subject {
      flex: 0 0 auto;
      box-sizing: border-box;
      width: 141px;
      height: 65px;
      margin-right: 7px;
      color: #9a6f45;
      font-weight: 500;
      font-size: 25px;
      line-height: 65px;
      text-align: center;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon6.png')
        no-repeat;
      background-size: 100%;
    }
    .subject.active {
      height: 76px;
      color: #fff;
      line-height: 65px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/icon7.png')
        no-repeat;
      background-size: 100%;
    }
  }
  .sub-tab {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    align-items: center;
    width: 678px;
    height: 58px;
    margin: 22px auto 0;
    overflow-x: scroll;
    white-space: nowrap;
    background: #fff;
    border-radius: 14px;
    .major {
      position: relative;
      flex: 0 0 auto;
      height: 58px;
      margin-right: 15px;
      padding: 0 18px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 58px;
    }
    .major.active {
      color: #9a6f45;
      font-weight: 400;
      font-size: 25px;
    }
    .major.active::after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      width: 29px;
      height: 7px;
      margin: 0 auto;
      background: #9a6f45;
      border-radius: 4px;
      content: '';
    }
  }
  .teacher {
    box-sizing: border-box;
    width: 678px;
    height: 351px;
    margin: 22px auto;
    background: linear-gradient(180deg, #fff 0%, #fbf2e6 100%);
    border-radius: 14px;
    .title {
      display: block;
      width: 197px;
      height: 58px;
      margin: 0 auto;
    }
    .banner {
      display: flex;
      flex-shrink: 0;
      flex-wrap: nowrap;
      align-items: flex-start;
      margin-left: 22px;
      overflow-x: scroll;
      .slide:last-child {
        margin-right: 22px;
      }
      .slide {
        width: 199px;
        margin-top: 18px;
        margin-right: 11px;
        .head {
          position: relative;
          width: 100%;
          height: 163px;
          overflow: hidden;
          text-align: center;
          background: linear-gradient(180deg, #ffdba9 0%, #fff4d7 100%);
          border-radius: 14px;
          .img {
            position: relative;
            top: 18px;
            width: 90%;
          }
          .name {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 47px;
            color: #fff;
            font-weight: 500;
            font-size: 22px;
            line-height: 47px;
            text-align: center;
            background: #1f202e;
            background: rgba($color: #000, $alpha: 0.6);
            border-radius: 0 0 14px 14px;
          }
        }
        .desc {
          display: -webkit-box;
          width: 199px;
          margin-top: 18px;
          overflow: hidden;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          line-height: 33px;
          text-overflow: ellipsis;
          word-wrap: break-word;

          /* autoprefixer: off */
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }
  .server {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
    padding: 0 36px;
    .title {
      display: block;
      width: 197px;
      height: 58px;
      margin: 0 auto;
    }
    .energy {
      width: 438px;
      background: linear-gradient(180deg, #fff 0%, #fbf2e6 100%);
      border-radius: 14px;
      .list {
        display: flex;
        flex-wrap: wrap;
        padding: 36px 0 18px 26px;
        .item {
          width: 130px;

          img {
            display: block;
            width: 72px;
            height: 72px;
            margin: 0 auto;
          }
          p {
            padding-top: 7px;
            padding-bottom: 18px;
            color: #333;
            font-weight: 400;
            font-size: 22px;
            text-align: center;
          }
        }
      }
    }
    .safeguard {
      width: 217px;
      background: #fff9f2;
      border-radius: 14px;
      .box {
        width: 100%;
        padding: 22px 22px 0 22px;
        .child {
          display: flex;
          align-items: center;
          width: 100%;
          margin-bottom: 22px;
          .icon {
            width: 36px;
            height: 36px;
          }
          p {
            width: 150px;
            padding-left: 4px;
            color: #333;
            font-weight: 400;
            font-size: 22px;
          }
          .arrow {
            width: 9px;
            height: 16px;
          }
        }
      }
    }
  }
  .video {
    position: relative;
    .play {
      display: block;
      width: 620px;
      height: 348px;
      margin: 22px auto;
      border-radius: 14px;
    }
    .empty {
      height: 7px;
    }
    .cover {
      width: 620px;
      height: 348px;
      margin: 22px auto;
      img {
        width: 100%;
      }
    }
  }
  .video,
  .question {
    width: 678px;
    margin: 0 auto;
    background: linear-gradient(180deg, #fff 0%, #fbf2e6 100%);
    border-radius: 14px;
    .title {
      display: block;
      width: 252px;
      height: 58px;
      margin: 0 auto;
    }
    ::v-deep p {
      min-height: 40px;
      color: #333;
      font-weight: 400;
      font-size: 22px;
      font-style: normal;
      line-height: 33px;
      text-align: left;
    }
  }
  .question {
    margin-top: 22px;
    > div {
      padding: 29px;
      ::v-deep p {
        color: #333;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 33px;
        text-align: left;
      }

      ::v-deep img {
        display: inline-block;
        max-width: 100% !important;
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 185px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/foot.png')
      no-repeat;
    background-size: 100%;
  }
  .chat {
    position: fixed;
    right: 0;
    bottom: 300px;
    z-index: 100;
    width: 127px;
    img {
      width: 100%;
    }
  }
}
</style>
